/** Import modules */

import { Link }             from "react-router-dom";

import { Helmet }           from "react-helmet-async";

import { gql }              from "@apollo/client";

import { useQuery }         from "@apollo/client";

import { useLocation, useNavigate, useParams } from "react-router-dom";

import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import {
    getRobotsDirective,
    normalizeLanguage
} from "../../../Configs/LanguageConfig";

import { TyresCatalog }     from "../../../Queries/Tyres";

import { WinterTyreSizes }  from "../../../Queries/Tyres";

import { WinterTyreManufacturers } from "../../../Queries/Tyres";

import { QueryAttributes }  from "../../../Hooks/TyresNavigator";

import { buildProvisionalProductPath } from "../../../Misc/Permalinks";

/** Import components */

import Breadcrumbs          from "../../../Components/Layout/Header/Breadcrumbs";

import Products              from "../../../Components/Products/Tyres/Catalog/Collection";

import ComponentLoader       from "../../../Components/Layout/Loaders/Loader";

import WinterPagination      from "../../../Components/Products/Tyres/WinterPagination";

import WinterSizeSelector    from "../../../Components/Products/Tyres/WinterSizeSelector";

import WinterCommercialFilters from "../../../Components/Products/Tyres/WinterCommercialFilters";

import WinterTyreTiers from "../../../Configs/WinterTyreTiers";

/** Import assets */

import "../../../Styles/WinterTyres.css";

import "../../../Styles/Products.css";

const WINTER_SIZE_PATTERN = /^(\d+(?:\.\d+)?)-(\d+(?:\.\d+)?)-r(\d+(?:\.\d+)?)$/i;

const VISUAL_MARKUP_QUERY = gql`query {

    visualMarkup {

        markupPercent

    }

}`;

/**
 *
 * @returns Winter tyre landing page shell
 *
 */

const WinterLanding = () => {

    const { search } = useLocation (),

    { t, i18n } = useTranslation (),

    navigate = useNavigate (),

    { size: sizeParameter } = useParams (),

    sizeMatch = sizeParameter?.match ( WINTER_SIZE_PATTERN ),

    size = sizeMatch ? {

        width: parseFloat ( sizeMatch[ 1 ] ).toString (),

        height: parseFloat ( sizeMatch[ 2 ] ).toString (),

        diameter: parseFloat ( sizeMatch[ 3 ] ).toString ()

    } : null,

    currentLanguage = normalizeLanguage ( i18n?.resolvedLanguage || i18n?.language ),

    searchParams = new URLSearchParams ( search ),

    dimensionVariables = {

        ...( size ? {

            width: [ parseFloat ( size.width ) ],

            height: [ parseFloat ( size.height ) ],

            diameter: [ size.diameter ]

        } : {} ),

        ...(! size && searchParams.get ( "w" ) ? { width: [ parseFloat ( searchParams.get ( "w" ) ) ] } : {} ),

        ...(! size && searchParams.get ( "h" ) ? { height: [ parseFloat ( searchParams.get ( "h" ) ) ] } : {} ),

        ...(! size && searchParams.get ( "d" ) ? { diameter: [ searchParams.get ( "d" ) ] } : {})

    },

    manufacturerVariables = searchParams.get ( "m" ) ? {

        manufacturer: searchParams.get ( "m" ).split ( "," )

    } : {},

    studsVariables = searchParams.get ( "st" ) ? {

        studs: [ searchParams.get ( "st" ) ]

    } : {},

    tierManufacturers = WinterTyreTiers[ searchParams.get ( "tier" ) ] || [],

    tierVariables = tierManufacturers.length ? { manufacturer: tierManufacturers } : {},

    paginationVariables = QueryAttributes ( new URLSearchParams ( search ) );

    const { loading: productsLoading, data, error } = useQuery ( TyresCatalog, {

        variables: {

            ...paginationVariables,

            ...( size ? {

                width: [ parseFloat ( size.width ) ],

                height: [ parseFloat ( size.height ) ],

                diameter: [ size.diameter ]

            } : {} ),

            season: [ "w" ],

            studs: searchParams.get ( "st" ) ? [ searchParams.get ( "st" ) ] : undefined,

            ...tierVariables,

            showSingles: true,

            isCTire: false

        },

        skip: Boolean ( sizeParameter && ! size )

    } ),

    { loading: sizeLoading, data: sizeData, error: sizeError } = useQuery ( WinterTyreSizes, {

        variables: { ...manufacturerVariables, ...tierVariables, ...studsVariables }

    } ),

    { loading: manufacturersLoading, data: manufacturersData } = useQuery ( WinterTyreManufacturers, {

        variables: { ...dimensionVariables, ...studsVariables }

    } ),

    { loading: visualMarkupLoading, data: visualMarkupData } = useQuery ( VISUAL_MARKUP_QUERY ),

    [ notification, setNotification ] = useState ( 0 ),

    loading = productsLoading || sizeLoading || manufacturersLoading || visualMarkupLoading,

    connection = data?.multiFieldProductSearch,

    products = connection?.edges || [],

    invalidSize = Boolean ( sizeParameter && ! size ),

    hasNonLanguageQuery = [ ...searchParams.keys () ].some ( key => key !== "lang" ),

    indexable = ! invalidSize && ! hasNonLanguageQuery && ( ! size || Boolean ( connection && connection.totalCount > 0 ) ),

    canonicalPath = size ? `/ziemas-riepas/${ sizeParameter }` : "/ziemas-riepas",

    hasCursor = Boolean ( searchParams.get ( "a" ) || searchParams.get ( "b" ) ),

    hasStaleCursor = Boolean ( ! productsLoading && ! error && ! products.length && hasCursor );

    const productPath = product => buildProvisionalProductPath ( product ),

    structuredData = {

        "@context": "https://schema.org",

        "@graph": [

            {

                "@type": "BreadcrumbList",

                itemListElement: [

                    {

                        "@type": "ListItem",

                        position: 1,

                        name: "Sākums",

                        item: "https://tireshop.lv/"

                    },

                    {

                        "@type": "ListItem",

                        position: 2,

                        name: size ? `Ziemas riepas ${ size.width }/${ size.height } R${ size.diameter }` : "Ziemas riepas",

                        item: `https://tireshop.lv${ canonicalPath }`

                    }

                ]

            },

            ...( indexable && products.length ? [

                {

                    "@type": "ItemList",

                    itemListElement: products.map ( ( { node: product }, index ) => ( {

                        "@type": "ListItem",

                        position: index + 1,

                        url: `https://tireshop.lv${ productPath ( product ) }`,

                        item: {

                            "@type": "Product",

                            name: `${ product.manufacturer.name } ${ product.model }`,

                            image: product.currentImage || undefined,

                            brand: {

                                "@type": "Brand",

                                name: product.manufacturer.name

                            },

                            sku: String ( product.id ),

                            offers: {

                                "@type": "Offer",

                                url: `https://tireshop.lv${ productPath ( product ) }`,

                                priceCurrency: "EUR",

                                price: Number ( product.priceList?.retail_price || 0 ).toFixed ( 2 ),

                                availability: product.productVendors?.some ( vendor => [ "qty", "qtyHour", "qtyDays", "qtyWeeks" ].some ( field => Number ( vendor[ field ] ) > 0 ) ) ? "https://schema.org/InStock" : "https://schema.org/PreOrder",

                                seller: {

                                    "@type": "Organization",

                                    name: "Tireshop.lv"

                                }

                            }

                        }

                    } ) )

                }

            ] : [])

        ]

    };

    useEffect ( () => {

        if ( ! hasStaleCursor ) return;

        [ "f", "l", "a", "b", "p", "lp" ].forEach ( key => searchParams.delete ( key ) );

        navigate ( {

            pathname: sizeParameter ? `/ziemas-riepas/${ sizeParameter }` : "/ziemas-riepas",

            search: searchParams.toString () ? `?${ searchParams.toString () }` : ""

        }, { replace: true } );

    }, [ hasStaleCursor, navigate, search, searchParams, sizeParameter ] );

    /** Render component */

    return ( <div className="container max-content-width winter-tyres-page">

        <Helmet>

            <title>{ size ? `Tireshop.lv | ${ t ( "winter_tyres" ) } ${ size.width }/${ size.height } R${ size.diameter }` : `Tireshop.lv | ${ t ( "winter_tyres" ) }` }</title>

            <meta
                name="description"
                content={ t ( "winter_tyres_meta_description" ) }
            />

            <link rel="canonical" href={ `https://tireshop.lv${ canonicalPath }` } />

            <meta
                name="robots"
                content={ indexable ? getRobotsDirective ( currentLanguage ) : "noindex,follow" }
            />

            <script type="application/ld+json">

                { JSON.stringify ( structuredData ) }

            </script>

        </Helmet>

        <Breadcrumbs collection={ [

            { name: t ( "winter_tyres" ), URI: "/ziemas-riepas" }

        ] } />

        <main className="winter-tyres-page__content">

            <section className="winter-tyres-page__intro" aria-labelledby="winter-tyres-title">

                <p className="winter-tyres-page__eyebrow">Tireshop.lv</p>

                <h1 id="winter-tyres-title">{ t ( "winter_tyres" ) }</h1>

                <p className="winter-tyres-page__lead">
                    { t ( "winter_tyres_intro" ) }
                </p>

                <div className="winter-tyres-page__actions">

                    <Link to="/shop/tyres" className="button">

                        { t ( "view_tyre_catalog" ) }

                    </Link>

                    <Link to="/content/montage" className="link">

                        { t ( "book_tyre_service" ) }

                    </Link>

                </div>

            </section>

            <section className="winter-tyres-page__selection" aria-labelledby="winter-tyres-selection-title">

                <div>

                    <p className="winter-tyres-page__eyebrow">{ t ( "tyre_selection" ) }</p>

                    <h2 id="winter-tyres-selection-title">{ t ( "choose_winter_tyres_by_size" ) }</h2>

                    <p>
                        { t ( "winter_size_intro" ) }
                    </p>

                </div>

                { sizeLoading ? <ComponentLoader minified={ true } /> : sizeError ? <p className="winter-tyres-page__state">{ t ( "winter_size_data_unavailable" ) }</p> : <WinterSizeSelector

                    combinations={ sizeData?.winterTyreSizes }

                    manufacturers={ manufacturersData?.winterTyreManufacturers }

                    size={ size } /> }

            </section>

            { invalidSize && <section className="winter-tyres-page__state winter-tyres-page__not-found" aria-labelledby="winter-size-not-found-title">

                <h2 id="winter-size-not-found-title">{ t ( "winter_size_not_found" ) }</h2>

                <p>{ t ( "winter_invalid_size" ) }</p>

                <Link to="/ziemas-riepas" className="button">{ t ( "back_to_winter_tyres" ) }</Link>

            </section> }

            { ! invalidSize && <WinterCommercialFilters

                size={ size }

                availableManufacturers={ manufacturersData?.winterTyreManufacturers } /> }

            { ! invalidSize && <section className="winter-tyres-page__products" aria-labelledby="winter-tyres-products-title">

                <div className="winter-tyres-page__section-heading">

                    <div>

                        <p className="winter-tyres-page__eyebrow">{ t ( "current_products" ) }</p>

                        <h2 id="winter-tyres-products-title">{ t ( "winter_tyres" ) }</h2>

                    </div>

                    { ! loading && ! error && <p>{ data?.multiFieldProductSearch?.totalCount || 0 } { t ( "products" ) }</p> }

                </div>

                { loading && <ComponentLoader /> }

                { error && <p className="winter-tyres-page__state">{ t ( "winter_products_load_error" ) }</p> }

                { ! loading && ! error && ! products.length && <p className="winter-tyres-page__state">{ t ( "winter_products_unavailable" ) }</p> }

                { ! loading && ! error && products.length > 0 && <div className="product-catalog winter-tyres-page__catalog">

                    <div className="layout">

                        <section>

                            <Products

                                layout="grid"

                                products={ products }

                                visualMarkup={ visualMarkupData?.visualMarkup }

                                notice={ { view: notification, set: setNotification } } />

                            <WinterPagination

                                pageInfo={ data.multiFieldProductSearch.pageInfo }

                                totalCount={ data.multiFieldProductSearch.totalCount }

                                basePath={ sizeParameter ? `/ziemas-riepas/${ sizeParameter }` : "/ziemas-riepas" } />

                        </section>

                    </div>

                </div> }

            </section> }

            <section className="winter-tyres-page__services" aria-labelledby="winter-tyres-services-title">

                <h2 id="winter-tyres-services-title">{ t ( "delivery_and_pickup" ) }</h2>

                <div className="winter-tyres-page__service-grid">

                    <article>

                        <h3>{ t ( "delivery_across_latvia" ) }</h3>

                        <p>{ t ( "choose_tyre_delivery_method" ) }</p>

                    </article>

                    <article>

                        <h3>{ t ( "pickup_at_krustpils" ) }</h3>

                        <p>{ t ( "pickup_at_tireshop_riga" ) }</p>

                    </article>

                    <article>

                        <h3>{ t ( "tyre_storage" ) }</h3>

                        <p>{ t ( "tyre_storage_info_pending" ) }</p>

                    </article>

                </div>

            </section>

        </main>

    </div> );

}

/** Export component */

export default WinterLanding;